import { CustomerLoanStatus, ResolutionStatus } from "common";

export interface LitigationData {
  caseName: string;
  caseNumber: string;
  hasLcpPolicy: boolean;
  hasLcfLoan: boolean;
  hasLcfApplication: boolean;
  lcfLoan: LitigationLoanData;
  litigationId: number;
  litigationResolutionStatus: ResolutionStatus;
  lcfApplicationId: number;
  lcpApplicationId: number;
  status: LitigationStatus;
}

export interface LitigationLoanData {
  loanId: number;
  drawAllowed: boolean;
  customerFacingStatus: CustomerLoanStatus;
  fullRepaymentDueDate: Date;
  isNPLLoan: boolean;
}

export interface LitigationHintData {
  caseName: string;
  caseNumber: string;
  litigationId: number;
}

export interface LitigationHintParams {
  caseNameOrNumber?: string;
}

export enum LitigationStatus {
  Open = "open",
  Pending = "pending",
  Approved = "approved",
  Declined  = "declined",
  Resolved = "resolved",
  NeedsAttention = 'needs-attention',
  Repayment = "repayment",
  PaymentDue = "payment-due"
}

export const LitigationStatusLabel = new Map<string, string>([
  [LitigationStatus.Open, "Open"],
  [LitigationStatus.Pending, "Pending"],
  [LitigationStatus.Resolved, "Case resolved"],
  [LitigationStatus.NeedsAttention, "Needs attention"],
  [LitigationStatus.Declined, "Declined"],
  [LitigationStatus.Approved, "Approved"],
  [LitigationStatus.Repayment, "Repayment"],
  [LitigationStatus.PaymentDue, "Payment due"]
]);
